import React from 'react'
import PropTypes from 'prop-types'

import { SidebarModalListItem } from '@domain-group/suit-theme'

const DomainListItem = (props) => {
  const {
    callbacks: { updateSSODomains },
    domain,
  } = props

  const { title } = domain

  return (
    <SidebarModalListItem
      title={title}
    >
      <SidebarModalListItem.Actions>
        <SidebarModalListItem.Icon onClick={() => updateSSODomains(domain)} type="delete" />
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

DomainListItem.propTypes = {
  callbacks: PropTypes.shape({
    updateSSODomains: PropTypes.func.isRequired,
  }).isRequired,
  domain: PropTypes.object.isRequired,
}

export default DomainListItem
